import { call, put, all, takeEvery } from "redux-saga/effects";
import {
  FETCH_SUB_MENU
} from "./actionTypes"
import {
  fetchSubMenuSuccess
} from "./actions";

import { makeAjax, url, showMessage } from "../../helpers/global_helper";
import { USER_MS_EXT } from "../../helpers/url_helper";

function* fetchSubMenu(data) {
  try {
    
    const response = yield call(
      makeAjax,
      url.USER_API.listGameProvider,
      data.payload,
      USER_MS_EXT
    );
    if (response.status == 'SUCCESS') {
      yield all([
        put(fetchSubMenuSuccess({ response: response.data }))
      ]);
    }
    else {
      showMessage(response);
    }
  } catch (error) {
    showMessage(error);
    
    // alert
  }
}

function* submenuListSaga() {
  yield takeEvery(FETCH_SUB_MENU, fetchSubMenu);
}

export default submenuListSaga;
